import { useEffect, useState } from 'react';
import './OrderDetails.scss';
import moment from 'moment/moment';
import { useDraggableSheet } from '../../../helpers/hooks';
import { capitalizeFirstLetter } from '../../../helpers/utilities';
import UpdateOrder from '../../components/UpdateOrder/UpdateOrder';
import { ORDER_STATUS_PENDING } from '../../constants/globals';
import { fromCentsToPounds } from '../../../helpers/money';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { setTopNavbar } from '../../Reducers/actions/navbarActions';
import { getOrderById, updateOrder } from '../../Reducers/actions/ordersActions';

const OrderDetails = () => {
  const params = useParams();
  const orderId = params.order_id;
  const [showUpdateOrder, setShowUpdateOrder] = useState(false);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setTopNavbar({
      title: 'Order details',
      back: true,
    }))
  }, []);
  const handleUpdateOrder = (status, order_id, carrier, tracking) => {
    dispatch(updateOrder(status, order_id, carrier, tracking))
    handleCloseUpdate();
  };

  const handleCloseUpdate = () => {
    setShowUpdateOrder(false);
  };
  const { order, loading, loading_update } = useSelector((state) => ({
    order: state?.orders?.currentOrder,
    loading: state?.orders?.loading,
    loading_update: state?.orders?.loading_update,
  }));

  useEffect(() => {
    if (order?.order_id !== orderId) {
      dispatch(getOrderById(orderId));
    }

  }, [orderId, order?.order_id]);

const handleShowUpdate = () => {
    setShowUpdateOrder(true);
  };

  // const [showUpdate, setShowUpdate] = useState(false);
  return (
    <div className="order-details">


      {order && <div className="sheet pt-16"
        onClick={(e) => e.stopPropagation()}
      >

        <div className="body">
          {order?.shipping_address_id && (() => {
            const shipName =
              order.shipping_address_info?.name ||
              [order.customer?.firstName, order.customer?.lastName]
                .filter(Boolean)
                .join(' ')
                .trim();
            const addr = order.shipping_address_info?.address || {};
            return (
              <div className="shipping-address-container mx-16">
                <p className="fs-xs fw-bold ">Shipping address</p>
                <p className="fs-regular fw-regular "> {shipName || '--'} </p>
                <p className="fs-regular fw-regular "> {addr.line1 || '--'} </p>
                {addr.line2 && <p className="fs-regular fw-regular "> {addr.line2} </p>}
                <p className="fs-regular fw-regular "> {addr.city || '--'} </p>
                <p className="fs-regular fw-regular "> {addr.postal_code || '--'} </p>
                {addr.state && <p className="fs-regular fw-regular "> {addr.state} </p>}
                <p className="fs-regular fw-regular "> {addr.country || '--'} </p>
              </div>
            );
          })()}
          <div className="field">
            <label>Order ID</label>
            <p>{order.order_id}</p>
          </div>
          <div className="field">
            <label>Date</label>
            <p>{moment(order.created_at).format('DD/MM/YYYY')}</p>
          </div>

          <div className="field">
            <label>Buyer</label>
            <p>{
              [order.customer?.firstName, order.customer?.lastName]
                .filter(Boolean)
                .join(' ')
                .trim() ||
              order.shipping_address_info?.name ||
              '--'
            }</p>
          </div>

          <div className="field">
            <label>Product</label>
            <p>{order.creation?.title}</p>
          </div>

          <div className="field">
            <label>Amount</label>
            <p>{fromCentsToPounds(order?.amount || 0)}</p>
          </div>

          <div className="field">
            <label>Status</label>
            <div className={`status ${order.order_status.toLowerCase()}`}>
              <span className="dot"></span>
              {capitalizeFirstLetter(order.order_status)}
            </div>
          </div>

          <div className="field">
            <label>Carrier</label>
            <p>{order.carrier || '--'}</p>
          </div>

          <div className="field last">
            <label>Tracking number</label>
            <p>{order.trackingNumber || '--'}</p>
          </div>
          {order.order_status === ORDER_STATUS_PENDING && <div className="footer-update-order">
          <button className="button_update-order" onClick={() => handleShowUpdate(true)}>
            Update Order
          </button>
        </div>}
        </div>

        
      </div>}
      {showUpdateOrder && (
        <UpdateOrder
          order_id={order?.order_id}
          onClose={handleCloseUpdate}
          onSubmit={handleUpdateOrder}
        />
      )}
    </div>
  );
};

export default OrderDetails; 